function ContactForm() {
  return (
    <section className="contactSection">

      <div>

        <div>
          <a className="contactItem" href="mailto: anthony.e.p3na@gmail.com">anthony.e.p3na@gmail.com</a>
        </div>

      </div>


    </section>

  );
}

export default ContactForm;
